import { render } from "./RoomCancellationPolicy.vue?vue&type=template&id=bc1f021e&scoped=true"
import script from "./RoomCancellationPolicy.vue?vue&type=script&lang=js"
export * from "./RoomCancellationPolicy.vue?vue&type=script&lang=js"

import "./RoomCancellationPolicy.vue?vue&type=style&index=0&id=bc1f021e&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_typescript@5.7.3__webpack@5.97.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc1f021e"]])

export default __exports__